import { captureConversationAccess } from 'dashboard/permissionSets/conversationReads';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

export default {
  markMessagesRead: async (context, data) => {
    const { commit } = context;
    const isCurrent = captureConversationAccess(context, data.id);
    try {
      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      if (!isCurrent()) return;
      setTimeout(() => {
        if (isCurrent())
          commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen });
      }, 4000);
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async (context, { id }) => {
    const { commit } = context;
    const isCurrent = captureConversationAccess(context, id);
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      if (!isCurrent()) return;
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      if (isCurrent()) throwErrorMessage(error);
    }
  },
};
